module.exports = __webpack_public_path__ + "img/20201026161411678.020571f8.jpg";